<script>
  import DeviceDetail from "./DeviceDetail.svelte";
  import DeviceGroup from "./DeviceGroup.svelte";
  import DevicesSelector from "./DevicesSelector.svelte";
  import NavBar from "./NavBar.svelte";
  import { toasts, ToastContainer, FlatToast } from "svelte-toasts";
  import { fade } from "svelte/transition";
  import {
    API_DIR,
    SESSION_LS,
    selectedPage,
    showLoadingModal,
    tableData,
    uniqueAppIdValuesList,
    uniqueConfigValuesList,
    uniqueFirmwareValuesList,
    uniqueMobileIdValuesList,
    uniqueScriptValuesList,
    uniqueClientValuesList,

    OTAP_STATE,

    OTAP_DIALOG


  } from "../store";
  import { selectedDeviceId } from "../store";
  import Firmware from "./Firmware.svelte";
  import ConfigRecords from "./ConfigFiles.svelte";
  import FirmwareFiles from "./FirmwareFiles.svelte";
  import ConfigDetail from "./ConfigDetail.svelte";
  import { convertUnixToDate, movePropertyToFront } from "../Utils.svelte";
  import { onMount } from "svelte";
  import ConfigUpdate from "./ConfigUpdate.svelte";
  import JobsViewer from "./JobsViewer.svelte";
  import CompletedJobs from "./CompletedJobs.svelte";
  import TaskUpdate from "./TaskUpdate.svelte";
  import Groups from "./Groups.svelte";

  const pages = [
    DevicesSelector, //0
    DeviceDetail, //1
    Firmware, //2
    DeviceGroup, //3
    ConfigRecords, //4
    FirmwareFiles, //5
    ConfigDetail, //6
    ConfigUpdate, //7
    JobsViewer, //8
    CompletedJobs, //9
    TaskUpdate, //10
    Groups //11
  ];

  //let showModal = false;
  showLoadingModal.set(false);
  let viewportComponent = null;
  //$: $selectedDeviceId, changeMainContent(1); //DeviceDetail
  $: $selectedDeviceId, changeMainContent(1); //DeviceDetail
  $: $tableData, ($showLoadingModal = $tableData.length == 0 ? true : false);

  function changeMainContent(page) {
    if ($selectedDeviceId != null && $selectedDeviceId != "null") {
      selectedPage.set(page);
    }

    //selectedPage = selectedPage == 0 ? 1 : 0;
  }

  //$: selectedDeviceId, console.log($selectedDeviceId);//DeviceDetail
  //$: selectedPage, updateViewportComponent();

  function updateViewportComponent() {
    console.log(pages[$selectedPage].name);
    viewportComponent = pages[$selectedPage];
  }

  async function fetchTableData() {
    const url = `${$API_DIR}/api/v1/devices`;

    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem($SESSION_LS) // Agrega el encabezado session_id desde el localStorage
      }
    };

    const response = await fetch(url, requestOptions);
    const data = await response.json();

    return data;
  }

  async function getAppIdList() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem($SESSION_LS)
      }
    };

    try {
      const response = await fetch(
        `${$API_DIR}/api/v1/get-app-id-list`,
        requestOptions
      );

      if (response.ok) {
        const data = await response.json();
        uniqueAppIdValuesList.set(
          data.sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
        );
      } else {
        toasts.error("Error getting App Id list");
      }
    } catch (error) {
      console.log("Error en la solicitud al servidor:", error);
      toasts.error("Error getting App Id list");
    }
  }

  async function sortedJsonData() {
    try {
      const dataTable = await fetchTableData();

      var parsedJsonData = [];
      var uniqueConfigValues = new Set();
      //var uniqueAppIdValues = new Set();
      var uniqueFirmwareValues = new Set();
      var uniqueMobileIdValues = new Set();
      var uniqueScriptdValues = new Set();
      var uniqueClientValues = new Set();

      Object.keys(dataTable).forEach((key) => {
        var unitData = dataTable[key];
        var jsonObj = { ...unitData };

        jsonObj.id_device = key;
        jsonObj.date = convertUnixToDate(jsonObj.date);

        jsonObj.carrier = jsonObj.imsi.slice(0,3) == "334" ? "Telcel" : "AT&T";	
        if (!jsonObj.hasOwnProperty("company")) {
          jsonObj.company = "-";
        }

        //console.log("OTA STAT");
        jsonObj.OTASTAT = jsonObj.OTASTAT.split(",");
        let otaStatus = jsonObj.OTASTAT[3];
        let otaDialog = jsonObj.OTASTAT[4];

        otaStatus = $OTAP_STATE[otaStatus] || "-";
        otaDialog = $OTAP_DIALOG[otaDialog] || "-";

        /*console.log("OTA STAT", otaStatus);
        console.log("OTA STAT", $OTAP_STATE[otaStatus]);

        console.log("OTA DIALOG", otaDialog);
        console.log("OTA DIALOG", $OTAP_DIALOG[otaDialog]);*/

        //console.log(jsonObj.OTASTAT);
        //console.log( $OTAP_STATE[(jsonObj.OTASTAT)[3]]);
       
        jsonObj.ota_status = otaStatus ;
        jsonObj.ota_dialog =  otaDialog ;

        var sortJsonObj = movePropertyToFront(jsonObj, "carrier");
        sortJsonObj = movePropertyToFront(jsonObj, "ota_status");
        sortJsonObj = movePropertyToFront(jsonObj, "ota_dialog");
        sortJsonObj = movePropertyToFront(jsonObj, "id_device");

        parsedJsonData.push(sortJsonObj);
  

        uniqueClientValues.add(jsonObj.company);
        uniqueConfigValues.add(jsonObj.config);
        uniqueFirmwareValues.add(jsonObj.app);
        uniqueMobileIdValues.add(jsonObj.mobile_ID_type);
        uniqueScriptdValues.add(jsonObj.script);
      });

      uniqueConfigValuesList.set(
        Array.from(uniqueConfigValues).sort((a, b) => a - b)
      );

      uniqueClientValuesList.set(Array.from(uniqueClientValues).sort());
      /*uniqueAppIdValuesList.set(
        Array.from(uniqueAppIdValues).sort((a, b) => a - b)
      );*/
      uniqueScriptValuesList.set(
        Array.from(uniqueScriptdValues).sort((a, b) => a - b)
      );
      uniqueFirmwareValuesList.set(Array.from(uniqueFirmwareValues));
      uniqueMobileIdValuesList.set(Array.from(uniqueMobileIdValues));

      return parsedJsonData;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  /*export function showToast(title, description, type) {
    const toast = toasts.add({
      title: title,
      description: description,
      duration: 3000, // 0 or negative to avoid auto-remove
      placement: "bottom-right",
      type: "info",
      theme: "light",
      placement: "bottom-right",
      showProgress: true,
      type: type,
      theme: "light",
      onClick: () => {},
      onRemove: () => {},
      // component: BootstrapToast, // allows to override toast component/template per toast
    });
  }*/

  sortedJsonData()
    .then((data) => {
      tableData.set(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  async function fetchData() {
    await sortedJsonData()
      .then((data) => {
        tableData.set(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  updateViewportComponent();

  onMount(() => {
    showLoadingModal.set(true);
    getAppIdList();

    const interval = setInterval(fetchData, 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  });
</script>

<div>
  <NavBar />

  <div class="container">
    <div class="card shadow-lg">
      <!--<div class="card-body" style="height:2600px">-->
      <div class="card-body" style="height:auto">
        <div>
          {#if viewportComponent == pages[$selectedPage]}
            <div
              id="main-page-container"
              style=""
              on:outroend={updateViewportComponent}
              transition:fade
            >
              <svelte:component this={viewportComponent} />
            </div>
          {/if}
        </div>
      </div>

      <br />
      <br />
    </div>
    <br />
    <div class="d-flex flex-row-reverse">
      <div class="fs-6 text text-secondary" style="">OMNI-PULS 1.0.1v</div>
    </div>
  </div>
</div>

<ToastContainer {toasts} let:data>
  <FlatToast {data} />
  <!-- default slot as toast component -->
</ToastContainer>

<!-- Modal -->
<div
  class={`modal fade ${$showLoadingModal ? "show" : "disappear"}`}
  tabindex="-1"
  style={`background-color: rgba(0, 0, 0, 0.5);`}
>
  <div
    class="modal-dialog modal-dialog-centered modal-lg"
    style="background-color: transparent;"
  >
    <div
      class="modal-content"
      style="background-color: transparent; border: none;"
    >
      <div
        class="modal-body d-flex justify-content-center"
        style="background-color: transparent;"
      >
        <div
          class={`spinner-grow text-primary`}
          style="width: 12rem; height: 12rem;"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Quitar disappear para obtener animación-->
<style>
  .fade {
    transition: opacity 0.15s linear;
  }

  .modal {
    display: block;
    opacity: 0;
    transition: opacity 0.15s linear;
    z-index: 1060;
  }

  .modal.show {
    opacity: 1;
  }

  .disappear {
    opacity: 1;
    transition: opacity 0.15s linear;
    transition-delay: 0.15s;
    display: none;
  }

  .hidden {
    opacity: 0;
    display: none;
  }
</style>
